import { LottieAnimator } from '~bergBlockPath/lottie-animator/js/core-event-handler';

class FlowCardAnimation {
  constructor( flowCardSection ) {
    this.flowCardSection = flowCardSection;
    this.fadeInDuration = 1500;
    this.lottieSpeed = 0.5;
    this.lottieQueue = [];
    this.slider = this.flowCardSection.find( '.bs-slider>div' );
    this.slideWrappers = this.slider.find( '.slick-slide-wrapper>div' );
  }

  playLottie( slideNumber, callback = null ) {
    const lottieAnimation = this.lottieQueue[slideNumber];
    if ( !lottieAnimation ) return;
    lottieAnimation.play();
    if ( callback ) {
      lottieAnimation.addEventListener( 'enterFrame', e => {
        if( e.currentTime > 1 ) {
          callback();
          lottieAnimation.removeEventListener( 'enterFrame' );
        }
      } );
    }
  }

  showSlide( slideNumber = 0 ) {
    const slideWrapper = this.slideWrappers.eq( slideNumber );
    const nextSlideWrapper = this.slideWrappers.eq( slideNumber + 1 );
    const p = slideWrapper.find( 'p' );
    const img = slideWrapper.find( '.media-elements' );

    const wrapperDuration = slideNumber === 0 ? 0 : ( this.fadeInDuration / 6 );
    const pDuration = ( this.fadeInDuration / 2 );
    const imgDuration = ( this.fadeInDuration / 3 );

    slideWrapper.fadeTo( wrapperDuration , 1, () => {
      p.fadeTo( pDuration, 1 );
      setTimeout( () => {
        img.fadeTo( imgDuration, 1, () => {
          if ( nextSlideWrapper?.length > 0 ) {
            this.playLottie( slideNumber, () => {
              this.showSlide( slideNumber + 1 );
            } );
          }
        } );
      }, 650 );
    } );
  }

  init() {
    this.slideWrappers.each( ( index, slide ) => {
      if ( index + 1 === this.slideWrappers.length ) return;
      slide = $( slide );
      const mediaElement = slide.find( '.media-elements' );
      const lottie = slide.find( '.bs-lottie-animator' );
      mediaElement.prepend( lottie );
      const lottieNativeElement = lottie.get( 0 );
      const animator = new LottieAnimator( lottieNativeElement );
      animator.init();
      const lottieAnimation = animator.lottieAnimation;
      lottieAnimation.goToAndStop( 0, true );
      lottieAnimation.setSpeed( this.lottieSpeed );
      this.lottieQueue.push( lottieAnimation );
    } );

    const observer = new IntersectionObserver(
      entries => {
        if ( entries[0].isIntersecting ) {
          setTimeout( () => {
            this.showSlide();
          }, 300 );
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.75,
      }
    );
    observer.observe( this.slider.get( 0 ) );
  }
}

$( () => {
  const flowCardSection = $( '.bs-section--flow-cards' );
  if ( flowCardSection.length === 0 ) return;

  const flowCardAnimation = new FlowCardAnimation( flowCardSection );
  flowCardAnimation.init();
} );
